import { render, staticRenderFns } from "./AlertErrors.vue?vue&type=template&id=7c8fb704&"
import script from "./AlertErrors.vue?vue&type=script&lang=js&"
export * from "./AlertErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c8fb704')) {
      api.createRecord('7c8fb704', component.options)
    } else {
      api.reload('7c8fb704', component.options)
    }
    module.hot.accept("./AlertErrors.vue?vue&type=template&id=7c8fb704&", function () {
      api.rerender('7c8fb704', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/form/components/AlertErrors.vue"
export default component.exports